import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import isEqual from "react-fast-compare";
import { useDispatch, useSelector } from "react-redux";
import BackArrow from "../../../../assets/BackArrow.svg";
import BackArrowWhite from "../../../../assets/WhiteIcons/BackArrow_White.svg";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";
import NetworkSettings from "./NetworkSettings";
import "./NetworkSettingDrawer.scss";
const NetworkSettingDrawer = ({ isOpen, isSettingDisable, headerHeight }) => {
  const dispatch = useDispatch();
  const headerRef = useRef(null);
  const [refUpdated, setRefUpdated] = useState(false);

  const measuredHeaderRef = useCallback((node) => {
    if (node !== null) {
      headerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);

  const authParams = useSelector((state) => state.Authentication.authParams);
  const isNetworkWidgetSettingEdit = useSelector(
    (state) => state?.Network?.isNetworkWidgetSettingEdit
  );
  const handleBackButton = () => {
    dispatch(setIsNetworkWidgetSettingEdit(false));
    dispatch(setNetworkWidgetSettingObject(null));
  };
  return (
    <>
      <div
        className={`col-12 ${
          isNetworkWidgetSettingEdit ? "col-md-4" : "d-none"
        } pl-0 pr-0 NetwokSettingDrawer`}
      >
        <div ref={measuredHeaderRef} className="bg__white">
          <div
            className="portlet__title fontSize-16 font-weight500 cursor-pointer bg__white border-bottom border-color"
            style={{ padding: "8px 10px" }}
          >
            <span className="d-flex align-items-center">
              <img
                src={
                  authParams?.theme_type === "1" ? BackArrowWhite : BackArrow
                }
                alt="Back Arrow"
                className="mr-1"
                style={{ maxWidth: "20px" }}
                onClick={handleBackButton}
              />
              {"Settings"}
            </span>
          </div>
        </div>
        <NetworkSettings
          isSettingDisable={false}
          headerHeight={
            headerRef?.current?.clientHeight
              ? headerRef?.current?.clientHeight
              : 60
          }
        />
      </div>
    </>
  );
};
export default React.memo(NetworkSettingDrawer, isEqual);
